const baseUrl = "https://test.txtconnect.net/";
// const baseUrl = "https://api.txtconnect.net/";

//comment by me 
//api comment

const Config = {
  baseUrl: baseUrl,
};

export default Config;
//commented out the test url and added the production url
